import { confirmDialog } from "../../components/Dialog/DialogDelete";
import { PRESCRIPTION } from "../../routes";
import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import {
    REQUEST_STATE_ID_COMPLETED,
    REQUEST_STATE_ID_CREATED,
    REQUEST_STATE_ID_DECLINED,
    REQUEST_STATE_ID_PROCESSING
} from "../../redux/constants/requestStateConstants";
import { commentDialog } from "../../components/Dialog/CommentDialog";
import { hasSignedProtocol } from "../../models/protocolStateIds";

const rejectSignedProtocolHint = (type) => {
    if (type === "Resolution") {
        return "По данному постановлению уже есть подписанный протокол.";
    }
    if (type === "Prescription") {
        return "По данному предписанию уже есть подписанный протокол.";
    }
    return "По данной заявке уже есть подписанный протокол.";
};

export const controlsKSEK = (
    row,
    reload,
    push,
    crud,
    returnRoute,
    handleGenerateObjectReferral,
    type,
    isInRoles,
    isAdministrator,
    options = {}
) => {
    const { protocols: protocolsOverride } = options;
    const protocolsForSignCheck = protocolsOverride ?? row?.protocols ?? [];
    const rejectBlockedBySignedProtocol = hasSignedProtocol(protocolsForSignCheck);
    const processingButtons = [];
    if (type === 'Prescription') {
        processingButtons.push(<Button onClick={async()=> await handleGenerateObjectReferral()}
            >Создать
            заявку по ГЗ</Button>);
    }
    if (row?.protocols?.length > 0) {
        processingButtons.push(<Button onClick={async () => {
            confirmDialog('Завершить', 'Вы действительно хотите завершить?', async () => {
                try {
                    await crud.workflowRun(row?.id, REQUEST_STATE_ID_PROCESSING, REQUEST_STATE_ID_COMPLETED)
                    reload()
                } catch (e) {
                    console.log(e);
                    alert.show(0, 'Не удалось завершить, ошибка ' + e);
                }
            })
        }} id="complete">
            Завершить
        </Button>);
    }
    if ((isInRoles && !isInRoles(['Committee'])) || (isAdministrator && isAdministrator())) {
        processingButtons.push(
            <Stack
                key="ksek-reject"
                direction="column"
                alignItems="flex-start"
                spacing={0.5}
                sx={{ maxWidth: 320 }}
            >
                <Button
                    color="warning"
                    disabled={rejectBlockedBySignedProtocol}
                    onClick={() => {
                        commentDialog('Изменение статуса', 'Укажите комментарий для отклонения.', async (_) => {
                            await crud.workflowRun(row?.id, REQUEST_STATE_ID_PROCESSING, REQUEST_STATE_ID_DECLINED, _?.comment);
                            reload();
                        });
                    }}
                >
                    Отклонить с комментариями
                </Button>
                {rejectBlockedBySignedProtocol ? (
                    <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.35 }}>
                        {rejectSignedProtocolHint(type)}
                    </Typography>
                ) : null}
            </Stack>
        );
    }
    processingButtons.push(<Button
        variant={"text"}
        onClick={() => push(returnRoute || PRESCRIPTION)}
    >
        Вернуться
    </Button>);

    const declinedButtons = [];
    if ((isInRoles && isInRoles(['Committee'])) || (isAdministrator && isAdministrator())) {
        declinedButtons.push(<Button
            color="warning"
            onClick={async () => {
                await crud.workflowRun(row?.id, REQUEST_STATE_ID_DECLINED, REQUEST_STATE_ID_CREATED);
                reload();
            }
            }
        >
            Пересоздать
        </Button>);
    }
    declinedButtons.push(<Button
            variant={"text"}
            onClick={() => push(returnRoute || PRESCRIPTION)}
        >
            Вернуться
        </Button>);

    return [
    {
        state: "created",
        roles: [],
        buttons: [
            ...((isInRoles && isInRoles(['Committee', 'CommitteeAdministrator'])) ? [
                <Button
                    key="ksek-delete"
                    color="warning"
                    onClick={() => {
                        confirmDialog('Удаление', 'Вы действительно хотите удалить этот документ?', async () => {
                            try {
                                await crud.delete(row?.id);
                                push(returnRoute || PRESCRIPTION);
                            } catch (e) {
                                console.log(e);
                                alert.show(0, 'Не удалось удалить, ошибка ' + e);
                            }
                        });
                    }}
                >
                    Удалить
                </Button>
            ] : []),
            <Button onClick={async () => {
                confirmDialog('Отправка в НЦЭ', 'Вы действительно хотите отправить эту заявку в НЦЭ?', async () => {
                    try {
                        await crud.workflowRun(row?.id, 1, 2)
                        reload()
                    } catch (e) {
                        console.log(e);
                        alert.show(0, 'Не удалось удалить, ошибка ' + e);
                    }
                })
            }} id="deleteReferal">
                Отправить в НЦЭ
            </Button>,
            <Button
                variant={"text"}
                onClick={() => push(returnRoute || PRESCRIPTION)}
            >
                Вернуться
            </Button>
        ],
    },
    {
        state: "processing",
        roles: [],
        buttons: processingButtons        
    },
    {
        state: "completed",
        roles: [],
        buttons: [
            <Button
                variant={"text"}
                onClick={() => push(returnRoute || PRESCRIPTION)}
            >
                Вернуться
            </Button>
        ],
    },
    {
        state: "declined",
        roles: [],
        buttons: declinedButtons,
    }
]
};
